"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patterned = void 0;
function patterned(_constraint_, v) {
    return v;
}
exports.patterned = patterned;
